import { initialState } from "./state"

// ---------------------------------------------------------------------------
// Generic dataset mutation (replaces 8 individual stat mutations)
// ---------------------------------------------------------------------------

export const setDatasetStat = (state, { dataset, key, value }) => {
  if (!state.datasets[dataset]) return
  state.datasets[dataset][key] = value
}

// ---------------------------------------------------------------------------
// Params & period type
// ---------------------------------------------------------------------------

export const setParams = (state, payload) => {
  state.params = payload
}

export const setComparisonParams = (state, payload) => {
  state.comparisonParams = payload
}

export const setPeriodType = (state, payload) => {
  state.periodType = payload
}

export const setComparisonPeriodType = (state, payload) => {
  state.comparisonPeriodType = payload
}

// ---------------------------------------------------------------------------
// Comparison mode
// ---------------------------------------------------------------------------

export const setComparisonMode = (state, payload) => {
  state.isComparisonMode = payload
}

// ---------------------------------------------------------------------------
// City stats
// ---------------------------------------------------------------------------

export const setCityStats = (state, payload) => {
  state.cityStats = payload
}

// ---------------------------------------------------------------------------
// Streaming request states
// ---------------------------------------------------------------------------

export const setStreamingRequestState = (state, { key, loading, error }) => {
  if (!state.streamingRequestStates[key]) return
  state.streamingRequestStates[key] = { loading, error }
}

export const setIsStreamingAnalyticsRequested = (state, payload) => {
  state.isStreamingAnalyticsRequested = payload
}

// ---------------------------------------------------------------------------
// Reset
// ---------------------------------------------------------------------------

export const reset = (state) => {
  const s = initialState()
  Object.keys(s).forEach((key) => {
    state[key] = s[key]
  })
}
